import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';
import * as HttpStatus from 'http-status-codes';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class JobDetailService {
  private url: string = environment.appUrl;
  constructor(
    private http: HttpClient
  ) {}

  public getDetail(jobNumber: string): Observable<any> {
    const getDetailUrl = this.url + 'jobs/' + jobNumber ;
    return this.http
      .get(getDetailUrl, {
        observe: 'response'
      })
      .map(
        res => {
          if (res.status === HttpStatus.OK) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  public getEquipmentList(jobNumber: string): Observable<any> {
    const getEquipmentListUrl = this.url + 'jobs/' + jobNumber + '/equipment-summary';
    return this.http
      .get(getEquipmentListUrl,
      {
        observe: 'response'
      })
      .map(
        res => {
          if (res.status === HttpStatus.OK) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  public getPMList(jobNumber: string): Observable<any> {
    const getPMListUrl = this.url + 'jobs/' + jobNumber + '/pm-summary';
    return this.http
      .get(getPMListUrl, {
        observe: 'response'
      })
      .map(
        res => {
          if (res.status === HttpStatus.OK) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  public changeCompletionDate(jobNumber: string, completionDate: string): Observable<any> {
        const changeCompletionDateurl = this.url + 'jobs/' + jobNumber + '/completion-date/' + completionDate;
        return this.http
            .put(changeCompletionDateurl, {
            }, {
                observe: 'response'
            })
            .map(
                res => {
                    if (res.status === 200) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-detail/job-detail.service.ts